import React from "react";

import { useNavigate } from "react-router-dom";

const CustomerDevices = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto">
      <div className="card p-8">
        <div className="text-center">
          <i className="fas fa-mobile-alt text-6xl text-primary-500 mb-4" />
          <h1 className="text-2xl font-bold mb-2">My Devices</h1>
          <p className="text-gray-500 mb-6">
            Device management is available on your Lunova Player homepage
          </p>
          <button
            className="btn btn-primary"
            onClick={() => navigate("/dashboard")}
          >
            <i className="fas fa-arrow-left mr-2" />
            Go to Lunova Player
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerDevices;
